/**
 * Feature flags read from NEXT_PUBLIC_ environment variables.
 */

export const isReelsEnabled =
  process.env.NEXT_PUBLIC_ENABLE_REELS !== "false";

// Priority alert fairness: after N priority alerts in a row, let one normal
// alert play so normal alerts aren't starved.
export const isPriorityAlertFairnessEnabled =
  process.env.PRIORITY_ALERT_FAIRNESS_ENABLED === "true";

export const priorityAlertFairnessLimit =
  Number(process.env.PRIORITY_ALERT_FAIRNESS_LIMIT) || 5;

export const isOverlayControlsEnabled =
  process.env.NEXT_PUBLIC_OVERLAY_CONTROLS_ENABLED === "true";

const overlayControlsWhitelistEnabled =
  process.env.NEXT_PUBLIC_OVERLAY_CONTROLS_WHITELIST_ENABLED === "true";

const overlayControlsWhitelistKeys = (
  process.env.NEXT_PUBLIC_OVERLAY_CONTROLS_WHITELIST_KEYS || ""
)
  .split(",")
  .map((k) => k.trim())
  .filter(Boolean);

/**
 * Whether overlay controls are available for a given stream key.
 *
 * Logic:
 * - If the global toggle is off → always false.
 * - If the whitelist is disabled → available to everyone (feature is fully rolled out).
 * - If the whitelist is enabled → only available to listed stream keys.
 *
 * @param {string} streamKey - the streamer's stream key
 */
export function isOverlayControlsAvailable(streamKey) {
  if (!isOverlayControlsEnabled) {
    return false;
  }
  if (!overlayControlsWhitelistEnabled) {
    return true;
  }
  return overlayControlsWhitelistKeys.includes(streamKey || "");
}
